import modelBaseV2 from "../model-base-v2.model";

/**
 * User Role Menu Map Model
 * 
 * Contains all the requests used by User Role Menu Map
 * 
 * @author cmcnkhiep(Ryan)
 */
const UserRoleMenuMapModel = {

  getUserRoleMenuByCountry: (userRole, systemType) => {
    const params = {userRole, systemType}
    return modelBaseV2.get('/api/userrole/menu/:userRole/:systemType',{ params });
  },
  
  saveUserRoleMenuByCountry: (body) => {
    return modelBaseV2.post('/api/userrole/menu', { body });
  },

}

export default UserRoleMenuMapModel;